export const validate = (values) => {
  let errors = {}

  if (!values.name) errors.name = 'Required'

  return errors
}
